import useGetColors from "../../utils/colors";
import t from "../../theme";

export const useGetBrandIconCardStyles = ({
  rounded,
  size,
  color,
  maxSize,
  isSelected,
  selectionWrapperStyles = {},
  imageViewStyles = {},
}) => {
  const { themeColors, brandCardColors } = useGetColors();

  const defaultSize = rounded ? 56 : 145;
  const cardSize = size || defaultSize;
  const maxDimensions = maxSize || cardSize;

  return {
    selectionWrapper: {
      width: cardSize,
      height: cardSize,
      borderRadius: rounded ? 500 : 12,
      maxWidth: maxDimensions,
      maxHeight: maxDimensions,
      position: "relative",
      overflow: "hidden",
      border: isSelected ? `solid 2px ${t.green.solid}` : t.border.base,
      boxShadow: isSelected ? t.shadow.brandFocus : t.shadow.sm,
      transition: t.transition.base,
      ...selectionWrapperStyles,
      "&:hover": {
        cursor: "pointer",
        borderColor: isSelected ? t.green.solid : t.border.colorMedium,
        boxShadow: isSelected ? t.shadow.brandFocus : t.shadow.md,
        transform: "scale(1.05)",
      },
    },
    cardWrapper: {
      width: "100%",
      height: "100%",
      borderRadius: rounded ? 500 : 12,
      paddingHorizontal: rounded ? 0 : 8,
      paddingVertical: rounded ? 0 : 8,
      backgroundColor: t.glass.primary,
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      borderWidth: color ? 0 : 1,
    },
    imageView: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      height: "100%",
      // transform: "scale(1.5)",
      overflow: "hidden",
      borderRadius: "50%",
      background: "#add8e63b",
      ...imageViewStyles,
    },
    favIcon: {
      position: "absolute",
      top: rounded ? "2px" : "-5px",
      // right: rounded ? '0.3rem' :'-4px',
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 999,
      padding: 5,
      marginTop: 10,
      backgroundColor: "rgba(255,255,255,0.7)!important",
      "&:hover": {
        backgroundColor: "#fff!important",
      },
    },
    actionWrapper: {
      position: "absolute",
      bottom: "2px",
      left: "0",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      // backgroundColor: "rgb(248 248 248 / 65%)",
      backdropFilter: "blur(6px)",
      alignItems: "center",
      overflow: "hidden",
      height: "25%",
    },
    actionWrapper1: {
      position: "absolute",
      bottom: "0",
      left: "0",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      // backgroundColor: "rgb(248 248 248 / 65%)",
      // backdropFilter: "blur(6px)",
      alignItems: "center",
      overflow: "hidden",
      height: "25%",
      // background: "rgb(255, 255, 255, 0.7)",
    },
    actionBtn: {
      fontSize: 4,
      paddingHorizontal: 0,
      borderRadius: 0,
      height: "100%",
      backgroundColor: brandCardColors.actionBtnBg,
      borderBottomLeftRadius: 9,
      borderBottomRightRadius: 9,
    },
    btnWrapper: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      alignItems: "center",
      gap: 6,
      "& svg": {
        fontSize: "1rem",
      },
    },
  };
};
